import { Avatar } from 'src/design/atoms/Avatar';
import { Divider } from 'src/design/atoms/Divider';
import { Group } from 'src/design/atoms/Group';
import { Text } from 'src/design/atoms/Text';
import { Tooltip } from 'src/design/atoms/Tooltip';
import { BasicActionIcon } from 'src/design/atoms/BasicActionIcon';
import { Menu } from 'src/design/molecules/Menu';
import { IconUserCircle } from '@tabler/icons-react';
import React from 'react';
import { UserCoreDto } from 'src/api/FiretrolApiClient';
import { useJobs } from 'src/hooks/useJobs';

interface IAssignToPickerProps {
  initialValue: UserCoreDto | null | undefined;
  onChange: (user: UserCoreDto | null) => void;
}

export const AssignToPicker: React.FC<IAssignToPickerProps> = ({
  initialValue,
  onChange,
}) => {
  const { users } = useJobs();
  const [selected, setSelected] = React.useState<UserCoreDto | null>(
    initialValue ?? null,
  );

  React.useEffect(() => {
    onChange(selected);
  }, [selected]);

  const selectUser = (user: UserCoreDto | null) => {
    setSelected(user);
  };

  const renderOptions = () => {
    if (users.length === 0) {
      return <Menu.Item disabled>No Users Assigned to Job</Menu.Item>;
    }
    return users.map((user) => {
      const isSelected = selected && selected.id === user.id;
      return (
        <Menu.Item
          key={user.id}
          leftSection={
            <Avatar size="xs" color="blue">
              {user.firstName.slice(0, 1)}
            </Avatar>
          }
          onClick={isSelected ? () => selectUser(null) : () => selectUser(user)}
        >
          <Group gap="xs">
            <Text c="black" size="sm">
              {user.fullName}
            </Text>
            {isSelected && (
              <Text size="xs" c="dimmed">
                (Click to unassign)
              </Text>
            )}
          </Group>
        </Menu.Item>
      );
    });
  };

  return (
    <Menu>
      <Menu.Target>
        <Tooltip label={selected ? selected.fullName : 'Assign to'}>
          <BasicActionIcon variant="subtle" size="sm">
            {selected ? (
              <Avatar size="sm" color="blue">
                {selected.firstName?.slice(0, 1)}
              </Avatar>
            ) : (
              <IconUserCircle size={20} />
            )}
          </BasicActionIcon>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>Assign to</Menu.Label>
        <Divider />
        {renderOptions()}
      </Menu.Dropdown>
    </Menu>
  );
};
